import { auth } from "@/auth";

import { getServerCart } from "./actions";
import { CartPageClient } from "./panier-client";

export default async function PanierPage() {
  const session = await auth();
  const serverCart = session?.user ? await getServerCart() : null;

  const serializedServerCart =
    serverCart && Array.isArray(serverCart.items)
      ? {
          ...serverCart,
          items: serverCart.items.map((item) => ({
            ...item,
            product: {
              ...item.product,
              price: Number(item.product.price),
              compareAtPrice: item.product.compareAtPrice
                ? Number(item.product.compareAtPrice)
                : null,
            },
          })),
        }
      : null;

  return (
    <CartPageClient
      isAuthenticated={!!session?.user}
      serverCart={serializedServerCart}
    />
  );
}